export const WORKFLOW_ONLY_ROLES = ["SUPERVISOR", "UNDER_SECRETARY"];

export const DEPARTMENT_USER_ROLE = "DEPARTMENT_USER";

/** Agent role (EXECUTIVE kept for legacy rows until migrated) */
export const AGENT_ROLES = ["AGENT", "EXECUTIVE"];

export const COMPLAINT_CREATOR_ROLES = [...AGENT_ROLES, "ADMIN", "MANAGER"];

export const isAgentRole = (userType) => AGENT_ROLES.includes(userType);

/** Legacy name — same as isAgentRole */
export const isExecutiveRole = isAgentRole;

const WORKFLOW_ALLOWED_PATHS = [
  "/",
  "/workflow-queue",
  "/workflow-history",
  "/logout",
];

// Field officers are DEPARTMENT_USER too — they need the officer portal, which
// SSO logins reached only because their session carried no userType. Allow it
// for every department user so email/password login behaves the same.
const DEPARTMENT_USER_ALLOWED_PATHS = [
  "/",
  "/workflow-queue",
  "/logout",
  "/officer",
  "/pendency-officer",
  "/pendency-officer-view",
];

export const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("call-center-admin-token")) || {};
  } catch {
    return {};
  }
};

export const getStoredUserType = () => getStoredUser()?.userType || "";

export const isWorkflowOnlyRole = (userType) =>
  WORKFLOW_ONLY_ROLES.includes(userType);

export const isDepartmentUserRole = (userType) =>
  userType === DEPARTMENT_USER_ROLE;

export const canViewPendingOnMe = (userType) =>
  COMPLAINT_CREATOR_ROLES.includes(userType);

export const canViewAllComplaints = (userType) => userType === "ADMIN";

export const REPORT_VIEWER_ROLES = ["ADMIN", "SUPERVISOR"];

export const canViewReports = (userType) =>
  REPORT_VIEWER_ROLES.includes(userType);

export const canViewOrgWideDashboard = (userType) =>
  REPORT_VIEWER_ROLES.includes(userType);

const REPORT_PATH_PREFIXES = [
  "/pendency",
  "/reports",
  "/school-report",
  "/vc-report",
];

export const isReportPath = (pathname) =>
  REPORT_PATH_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`) || pathname.startsWith(`${p}?`)
  );

export const isPathAllowedForRole = (userType, pathname) => {
  if (isWorkflowOnlyRole(userType)) {
    if (pathname === "/") return true;
    if (userType === "SUPERVISOR" && isReportPath(pathname)) return true;
    return WORKFLOW_ALLOWED_PATHS.some(
      (p) => p !== "/" && (pathname === p || pathname.startsWith(`${p}/`))
    );
  }
  if (isDepartmentUserRole(userType)) {
    if (pathname === "/") return true;
    return DEPARTMENT_USER_ALLOWED_PATHS.some(
      (p) => p !== "/" && (pathname === p || pathname.startsWith(`${p}/`))
    );
  }
  if (!canViewReports(userType) && isReportPath(pathname)) {
    return false;
  }
  return true;
};

export const getWorkflowQueueLabel = (userType) => {
  if (userType === "SUPERVISOR") return "Tag & Assign";
  if (userType === "UNDER_SECRETARY") return "Verify Queue";
  if (userType === DEPARTMENT_USER_ROLE) return "My Actions";
  return "My Queue";
};

export const getWorkflowHistoryLabel = (userType) => {
  if (userType === "SUPERVISOR") return "My Mapped History";
  if (userType === "UNDER_SECRETARY") return "My Approval History";
  return "Processed History";
};

/** Role filter: Agent includes legacy EXECUTIVE users */
export const matchesAgentRoleFilter = (userType, filter) => {
  if (!filter) return true;
  if (filter === "AGENT") return isAgentRole(userType);
  return userType === filter;
};
